import { useNavigate } from 'react-router-dom'
import { useLang } from '../../context/LangContext'
import StatusBadge from '../Badge/StatusBadge'

function getTicketIcon(ticket) {
  const text = `${ticket.title || ''} ${ticket.category || ''}`.toLowerCase()

  if (text.includes('printer')) return '🖨'
  if (text.includes('network') || text.includes('connectivity')) return '⌁'
  if (text.includes('hr')) return '▭'
  if (text.includes('hardware')) return '🖥'

  return '🎫'
}

export default function TicketRow({ ticket, variant = '' }) {
  const navigate = useNavigate()
  const { t } = useLang()

  const statusLabel = {
    new:         t('statusNew'),
    open:        t('statusOpen'),
    in_progress: t('statusInProgress'),
    resolved:    t('statusResolved'),
  }[ticket.status]

  return (
    <div
      className={`ticket-row ${variant === 'filled' ? 'ticket-row--filled' : ''}`}
      onClick={() => navigate(`/tickets/${ticket.id}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && navigate(`/tickets/${ticket.id}`)}
    >
      <span className="ticket-row__icon">{getTicketIcon(ticket)}</span>

      <div className="ticket-row__body">
        <div className="ticket-row__title">{ticket.title}</div>
        <div className="ticket-row__meta">{ticket.category} · {ticket.updatedAgo}</div>
      </div>

      <div className="ticket-row__side">
        <StatusBadge status={ticket.status} labelOverride={statusLabel} />
        <span className="ticket-row__id">{ticket.ref}</span>
      </div>
    </div>
  )
}
